interface User {
  accessToken: string | null,
  client: string | null,
  uid: string | null,
  lastOperatedDate: string | null | Date
}

const state = (): User => ({
  accessToken: null,
  client: null,
  uid: null,
  lastOperatedDate: null
})

const mutations = {
  setLastOperatedDate(state: User, payload: any) {
    state.lastOperatedDate = payload.lastOperatedDate
  },

  login(state: User, payload: any) {
    state.accessToken = payload.accessToken
    state.client = payload.client
    state.uid = payload.uid
  },

  logout(state: User) {
    state.accessToken = null
    state.client = null
    state.uid = null
  }
}

export default {
  namespaced: true,
  state,
  mutations,
}
